import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { billingSettingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { BillingSettings } from '@/types/settings';

/**
 * Fetch the unified Billing settings (six tabs per spec §10). The backend
 * synthesizes spec defaults for any missing fields, so this hook always
 * returns a fully populated `BillingSettings` shape on success.
 */
export function useBillingSettings({ enabled = true }: { enabled?: boolean } = {}) {
  return useApiQuery<BillingSettings>({
    queryKey: settingsKeys.billingSettings(),
    queryFn: () => apiGet<BillingSettings>(operationsClient, billingSettingsEndpoints.get()),
    showErrorToast: false,
    enabled,
  });
}
